import { cn, Skeleton } from '@/core/ui';
import { GetIdDetailsDocument } from '@/graphql/gql/graphql';
import { useQuery } from '@/libs';

export const AsyncId = ({ ids, table, className }: { ids: any[]; table: string; className?: string }) => {
  const { data, loading } = useQuery(GetIdDetailsDocument, {
    variables: { ids: ids.filter(Boolean), table },
    skip: !ids || !table || ids.length === 0,
  });

  if (!ids || !table || ids.length === 0) return <span>-</span>;

  if (!data?.admin?.getIdDetails || loading) return <Skeleton className='w-10 h-4' />;

  return (
    <span className={cn('line-clamp-2 w-64 text-end', className)}>
      {data.admin.getIdDetails?.length > 0
        ? data.admin.getIdDetails.map(
            (d) =>
              d && (
                <span key={`${d.id}-${table}`}>
                  {d.name} ({d.id})
                </span>
              ),
          )
        : '-'}
    </span>
  );
};
